/**
 * `useChronoSonore` — le bip des cinq dernières secondes (`chrono_last5`, SPEC-UI §7.6).
 *
 * Quatre des cinq mini-jeux ont un chrono, et le son de tension est le même partout : un
 * hook plutôt que quatre copies. Il tape **une fois par seconde**, jamais à chaque frame —
 * c'est la seule subtilité, et c'est celle qu'on rate quand on l'écrit à la va-vite dans une
 * boucle `requestAnimationFrame`.
 */

import { useEffect, useRef } from "react";

import { useSfx } from "../../components/SoundProvider";

/** Nombre de secondes de tension avant la fin. */
export const SECONDES_DE_TENSION = 5;

export function useChronoSonore(restantMs: number, actif: boolean): void {
  const sfx = useSfx();
  const derniereSeconde = useRef<number | null>(null);

  useEffect(() => {
    if (!actif) {
      derniereSeconde.current = null;
      return;
    }
    const seconde = Math.ceil(restantMs / 1000);
    if (seconde > SECONDES_DE_TENSION || seconde <= 0) return;
    if (derniereSeconde.current === seconde) return;
    derniereSeconde.current = seconde;
    sfx("chrono_last5");
  }, [restantMs, actif, sfx]);
}
